import _implicitStylesheets from "./configMigration.css";

import _implicitScopedStylesheets from "./configMigration.scoped.css?scoped=true";

import _myPageHeader from "my/pageHeader";
import _myPanelHeader from "my/panelHeader";
import _myLoginCard from "my/loginCard";
import _myOrgDetailsPanel from "my/orgDetailsPanel";
import _mySourceDataTable from "my/sourceDataTable";
import _lightningTab from "lightning/tab";
import _myTranslations from "my/translations";
import _lightningTabset from "lightning/tabset";
import _myPropertiesModal from "my/propertiesModal";
import _myErrorModal from "my/errorModal";
import _lightningSpinner from "lightning/spinner";
import _myTargetTabset from "my/targetTabset";
import _myToastMessage from "my/toastMessage";
import _lightningButton from "lightning/button";
import {registerTemplate} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, c: api_custom_element, h: api_element, gid: api_scoped_id, t: api_text, d: api_dynamic_text} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6, _m7, _m8, _m9, _m10, _m11, _m12, _m13, _m14, _m15, _m16, _m17, _m18, _m19, _m20, _m21, _m22, _m23, _m24} = $ctx;
  return [api_element("div", {
    classMap: {
      "slds-page-header-margin": true
    },
    key: 0
  }, [api_custom_element("my-page-header", _myPageHeader, {
    key: 1,
    on: {
      "selectedview": _m0 || ($ctx._m0 = api_bind($cmp.hanldeSelectedview))
    }
  }, [])]), api_element("div", {
    key: 2
  }, [api_element("div", {
    classMap: {
      "page-layout_split": true,
      "page-layout_left": true
    },
    key: 3
  }, [api_custom_element("my-panel-header", _myPanelHeader, {
    props: {
      "cardNumber": "1",
      "title": "Configuration Source",
      "menuOptions": $cmp.sourceMenuOptions,
      "menuTitle": "Options",
      "enableOptions": $cmp.isSourceOptionsEnabled
    },
    key: 4,
    on: {
      "orguserdetails": _m1 || ($ctx._m1 = api_bind($cmp.showOrgUserDetails)),
      "sourcepropertiesmodal": _m2 || ($ctx._m2 = api_bind($cmp.handleSourcePropertiesModal)),
      "logoutsourceorg": _m3 || ($ctx._m3 = api_bind($cmp.logoutSourceOrg)),
      "backbuttonclick": _m4 || ($ctx._m4 = api_bind($cmp.handleBackButton))
    }
  }, []), !$cmp.isSourceOptionsEnabled ? api_element("div", {
    key: 5
  }, [api_custom_element("my-login-card", _myLoginCard, {
    props: {
      "cardNumber": "1",
      "cardTitle": "Select Configuration Source",
      "connectToOrgtitle": "Connect to Source",
      "showFileUpload": true
    },
    key: 6,
    on: {
      "connecttoorg": _m5 || ($ctx._m5 = api_bind($cmp.getSalesforceSession)),
      "uploadfile": _m6 || ($ctx._m6 = api_bind($cmp.handleFilesChange))
    }
  }, [])]) : null, api_custom_element("my-org-details-panel", _myOrgDetailsPanel, {
    props: {
      "isUserLoggedIn": $cmp.isSourceOrgLoggedIn,
      "userName": $cmp.sourceUsername,
      "organizationId": $cmp.sourceOrganizationId
    },
    key: 7
  }, []), $cmp.isSourceOptionsEnabled ? api_custom_element("lightning-tabset", _lightningTabset, {
    classMap: {
      "configurations-tabset__height": true
    },
    attrs: {
      "data-my-id": "configelements-tabset"
    },
    props: {
      "variant": "scoped",
      "activeTabValue": $cmp.activeTabValue
    },
    key: 8
  }, [api_custom_element("lightning-tab", _lightningTab, {
    classMap: {
      "tab-height__align": true
    },
    attrs: {
      "data-my-id": "configElementsTab"
    },
    props: {
      "label": $cmp.configElementsTabTitle,
      "value": $cmp.configElementsTabTitle
    },
    key: 9,
    on: {
      "active": _m7 || ($ctx._m7 = api_bind($cmp.handleActive))
    }
  }, [api_custom_element("my-source-data-table", _mySourceDataTable, {
    classMap: {
      "datatable-tab__height": true
    },
    props: {
      "data": $cmp.configurations,
      "istargetorgloggedin": $cmp.isTargetOrgLoggedIn,
      "issearchenabled": $cmp.isSearchEnabled,
      "preselectedrowsids": $cmp.preSelectedRowsIds,
      "targettreegriddata": $cmp.beforeSearchRows,
      "searchvalue": $cmp.searchValue,
      "isexportbtndisabled": $cmp.isExportBtnDisabled,
      "originalconfigurations": $cmp.originalConfigurations
    },
    key: 10,
    on: {
      "selectedsourcegridrows": _m8 || ($ctx._m8 = api_bind($cmp.handleSelectedSourceGridRows)),
      "sourcedatatablesearch": _m9 || ($ctx._m9 = api_bind($cmp.handleSourceDataTableSearch))
    }
  }, [])]), api_custom_element("lightning-tab", _lightningTab, {
    classMap: {
      "tab-height__align": true
    },
    attrs: {
      "data-my-id": "translationsTab"
    },
    props: {
      "label": $cmp.translationsTabTitle,
      "value": $cmp.translationsTabTitle
    },
    key: 11,
    on: {
      "active": _m10 || ($ctx._m10 = api_bind($cmp.handleActive))
    }
  }, [api_custom_element("my-translations", _myTranslations, {
    classMap: {
      "datatable-tab__height": true
    },
    props: {
      "data": $cmp.translations,
      "preselectedrowsids": $cmp.preSelectedRowsIds,
      "isexportbtndisabled": $cmp.isExportBtnDisabled
    },
    key: 12,
    on: {
      "selectedsourcegridrows": _m11 || ($ctx._m11 = api_bind($cmp.handleSelectedSourceGridRows))
    }
  }, [])])]) : null, api_custom_element("my-properties-modal", _myPropertiesModal, {
    props: {
      "isModalOpen": $cmp.isOrgInfoModalOpen,
      "modalTitle": "Source Properties",
      "orgUserDetails": $cmp.orgUserDetails
    },
    key: 13
  }, []), api_custom_element("my-error-modal", _myErrorModal, {
    props: {
      "isModalOpen": $cmp.isMigrationStatusModalOpen,
      "modalTitle": $cmp.migrationsStatusTitle,
      "migrateStatusData": $cmp.migrationStatusData
    },
    key: 14
  }, []), $cmp.isSourceOrgDataLoaded ? api_custom_element("lightning-spinner", _lightningSpinner, {
    props: {
      "variant": "brand",
      "alternativeText": "source org data loading"
    },
    key: 15
  }, []) : null]), api_element("div", {
    classMap: {
      "page-layout_split": true,
      "page-layout_right": true
    },
    key: 16
  }, [api_custom_element("my-panel-header", _myPanelHeader, {
    props: {
      "cardNumber": "2",
      "title": "Destination",
      "menuOptions": $cmp.targetMenuOptions,
      "menuTitle": "Options",
      "enableOptions": $cmp.isTargetOptionsEnabled
    },
    key: 17,
    on: {
      "logoutdestinationorg": _m12 || ($ctx._m12 = api_bind($cmp.logoutTargetOrg)),
      "targetpropertiesmodal": _m13 || ($ctx._m13 = api_bind($cmp.handleTargetPropertiesModal))
    }
  }, []), !$cmp.isTargetOptionsEnabled ? api_element("div", {
    key: 18
  }, [api_custom_element("my-login-card", _myLoginCard, {
    props: {
      "cardNumber": "2",
      "cardTitle": "Select Destination",
      "connectToOrgtitle": "Connect to Destination",
      "disableCard": $cmp.disableTargetLoginCard
    },
    key: 19,
    on: {
      "connecttoorg": _m14 || ($ctx._m14 = api_bind($cmp.getSalesforceSession))
    }
  }, [])]) : null, api_custom_element("my-org-details-panel", _myOrgDetailsPanel, {
    props: {
      "isUserLoggedIn": $cmp.isTargetOptionsEnabled,
      "userName": $cmp.targetUsername,
      "organizationId": $cmp.targetOrganizationId
    },
    key: 20
  }, []), $cmp.isTargetOptionsEnabled ? api_element("div", {
    key: 21
  }, [api_custom_element("my-target-tabset", _myTargetTabset, {
    key: 22,
    on: {
      "migratecomplete": _m15 || ($ctx._m15 = api_bind($cmp.handleMigrateComplete)),
      "migrateerror": _m16 || ($ctx._m16 = api_bind($cmp.handleMigrateError))
    }
  }, [])]) : null, $cmp.isTargetOrgDataLoaded ? api_custom_element("lightning-spinner", _lightningSpinner, {
    props: {
      "variant": "brand",
      "alternativeText": "target org data loading"
    },
    key: 23
  }, []) : null]), api_element("div", {
    key: 24
  }, [api_custom_element("my-toast-message", _myToastMessage, {
    key: 25,
    on: {
      "showerrormodal": _m17 || ($ctx._m17 = api_bind($cmp.showErrorModal))
    }
  }, [])]), $cmp.showValidateDeploySpinner ? api_element("div", {
    key: 26
  }, [api_custom_element("lightning-spinner", _lightningSpinner, {
    props: {
      "variant": "brand",
      "alternativeText": "Migrating the data..."
    },
    key: 27
  }, [])]) : null, api_element("div", {
    key: 28
  }, [$cmp.isConfExported ? api_custom_element("lightning-spinner", _lightningSpinner, {
    props: {
      "variant": "brand",
      "alternativeText": "exporting configurations..."
    },
    key: 29
  }, []) : null]), $cmp.isSessionExpiredModalOpen ? api_element("div", {
    key: 30
  }, [api_element("section", {
    classMap: {
      "slds-modal": true,
      "slds-fade-in-open": true
    },
    attrs: {
      "role": "dialog",
      "tabindex": "-1",
      "aria-labelledby": api_scoped_id("modal-heading-04"),
      "aria-modal": "true",
      "aria-describedby": api_scoped_id("modal-content-id-4")
    },
    key: 31
  }, [api_element("div", {
    classMap: {
      "slds-modal__container": true,
      "fitler-modal_div": true,
      "confirm-modal_align": true
    },
    key: 32
  }, [api_element("header", {
    classMap: {
      "slds-modal__header": true
    },
    key: 33
  }, [api_element("h2", {
    classMap: {
      "slds-modal__title": true,
      "slds-hyphenate": true
    },
    attrs: {
      "id": api_scoped_id("modal-heading-04")
    },
    key: 34
  }, [api_text("Session Expired")])]), api_element("div", {
    classMap: {
      "slds-modal__content": true,
      "slds-p-around_medium": true
    },
    attrs: {
      "id": api_scoped_id("modal-content-id-4")
    },
    key: 35
  }, [api_element("h3", {
    key: 36
  }, [api_text("Your session has expired. Please login again.")]), api_element("br", {
    key: 37
  }, [])]), api_element("footer", {
    classMap: {
      "slds-modal__footer": true
    },
    styleDecls: [["text-align", "center", false]],
    key: 38
  }, [api_custom_element("lightning-button", _lightningButton, {
    classMap: {
      "session-expire-modal__align": true
    },
    props: {
      "label": "OK",
      "variant": "brand",
      "title": "OK"
    },
    key: 39,
    on: {
      "click": _m18 || ($ctx._m18 = api_bind($cmp.handleSessionExpire))
    }
  }, [])])])]), api_element("div", {
    classMap: {
      "slds-backdrop": true,
      "slds-backdrop_open": true
    },
    key: 40
  }, [])]) : null]), $cmp.isSourceOrgLogout ? api_element("div", {
    key: 41
  }, [api_element("section", {
    classMap: {
      "slds-modal": true,
      "slds-fade-in-open": true
    },
    attrs: {
      "role": "dialog",
      "tabindex": "-1",
      "aria-labelledby": api_scoped_id("modal-heading-01"),
      "aria-modal": "true",
      "aria-describedby": api_scoped_id("modal-content-id-1")
    },
    key: 42
  }, [api_element("div", {
    classMap: {
      "slds-modal__container": true,
      "disconnect-modal__align": true
    },
    key: 43
  }, [api_element("header", {
    classMap: {
      "slds-modal__header": true
    },
    key: 44
  }, [api_element("h2", {
    classMap: {
      "slds-modal__title": true,
      "slds-hyphenate": true
    },
    attrs: {
      "id": api_scoped_id("modal-heading-01")
    },
    key: 45
  }, [api_text(api_dynamic_text($cmp.logoutModalHeader))])]), api_element("div", {
    classMap: {
      "slds-modal__content": true,
      "slds-p-around_medium": true
    },
    attrs: {
      "id": api_scoped_id("modal-content-id-1")
    },
    key: 46
  }, [api_element("p", {
    key: 47
  }, [api_text(api_dynamic_text($cmp.logoutModalMessage))]), api_element("p", {
    classMap: {
      "modal-text__align": true
    },
    key: 48
  }, [api_text(api_dynamic_text($cmp.logoutModalConfirmMessage))])]), api_element("footer", {
    classMap: {
      "slds-modal__footer": true
    },
    key: 49
  }, [api_element("button", {
    classMap: {
      "slds-button": true,
      "slds-button_neutral": true
    },
    key: 50,
    on: {
      "click": _m19 || ($ctx._m19 = api_bind($cmp.cancelSourceOrgDisconnect))
    }
  }, [api_text("Cancel")]), api_element("button", {
    classMap: {
      "slds-button": true,
      "slds-button_brand": true
    },
    key: 51,
    on: {
      "click": _m20 || ($ctx._m20 = api_bind($cmp.handleSourceOrgDisconnect))
    }
  }, [api_text("Yes - Disconnect")])])])]), api_element("div", {
    classMap: {
      "slds-backdrop": true,
      "slds-backdrop_open": true
    },
    key: 52
  }, [])]) : null, $cmp.isTabChange ? api_element("div", {
    key: 53
  }, [api_element("section", {
    classMap: {
      "slds-modal": true,
      "slds-fade-in-open": true
    },
    attrs: {
      "role": "dialog",
      "tabindex": "-1",
      "aria-labelledby": api_scoped_id("modal-heading-01"),
      "aria-modal": "true",
      "aria-describedby": api_scoped_id("modal-content-id-1")
    },
    key: 54
  }, [api_element("div", {
    classMap: {
      "slds-modal__container": true,
      "warning-modal__align": true
    },
    key: 55
  }, [api_element("header", {
    classMap: {
      "slds-modal__header": true
    },
    key: 56
  }, [api_element("h2", {
    classMap: {
      "slds-modal__title": true,
      "slds-hyphenate": true
    },
    attrs: {
      "id": api_scoped_id("modal-heading-02")
    },
    key: 57
  }, [api_text(api_dynamic_text($cmp.warningText))])]), api_element("div", {
    classMap: {
      "slds-modal__content": true,
      "slds-p-around_medium": true
    },
    attrs: {
      "id": api_scoped_id("modal-content-id-2")
    },
    key: 58
  }, [api_element("p", {
    key: 59
  }, [api_text("Selection of " + api_dynamic_text($cmp.selectedType) + " will be lost when the tab is changed.")])]), api_element("footer", {
    classMap: {
      "slds-modal__footer": true,
      "warning-modal__footer": true
    },
    key: 60
  }, [api_element("button", {
    classMap: {
      "slds-button": true,
      "slds-button_neutral": true,
      "button-padding__right": true
    },
    key: 61,
    on: {
      "click": _m21 || ($ctx._m21 = api_bind($cmp.cancelWarningModal))
    }
  }, [api_text("Cancel")]), api_element("button", {
    classMap: {
      "slds-button": true,
      "slds-button_brand": true
    },
    key: 62,
    on: {
      "click": _m22 || ($ctx._m22 = api_bind($cmp.handleWarningModal))
    }
  }, [api_text("OK")])])])]), api_element("div", {
    classMap: {
      "slds-backdrop": true,
      "slds-backdrop_open": true
    },
    key: 63
  }, [])]) : null, $cmp.isConfSelectedToExport ? api_element("div", {
    key: 64
  }, [api_element("section", {
    classMap: {
      "slds-modal": true,
      "slds-fade-in-open": true
    },
    attrs: {
      "role": "dialog",
      "tabindex": "-1",
      "aria-labelledby": api_scoped_id("modal-heading-05"),
      "aria-modal": "true",
      "aria-describedby": api_scoped_id("modal-content-id-5")
    },
    key: 65
  }, [api_element("div", {
    classMap: {
      "slds-modal__container": true,
      "fitler-modal_div": true,
      "confirm-modal_align": true
    },
    key: 66
  }, [api_element("div", {
    classMap: {
      "slds-modal__content": true,
      "slds-p-around_medium": true
    },
    attrs: {
      "id": api_scoped_id("modal-content-id-5"),
      "data-my-id": "noConfItems"
    },
    key: 67
  }, [api_element("h3", {
    classMap: {
      "conf-modal_align": true
    },
    key: 68
  }, [api_text("No " + api_dynamic_text($cmp.activeTabValue) + " items have been selected for Export")]), api_element("br", {
    key: 69
  }, [])]), api_element("footer", {
    classMap: {
      "slds-modal__footer": true,
      "modal-bottom_align": true
    },
    key: 70
  }, [api_custom_element("lightning-button", _lightningButton, {
    classMap: {
      "modal-popup__margin": true
    },
    props: {
      "label": "OK",
      "variant": "brand",
      "title": "OK"
    },
    key: 71,
    on: {
      "click": _m23 || ($ctx._m23 = api_bind($cmp.closeExportConfModal))
    }
  }, [])])])]), api_element("div", {
    classMap: {
      "slds-backdrop": true,
      "slds-backdrop_open": true
    },
    key: 72
  }, [])]) : null, $cmp.isTargetPackageVersionLower ? api_element("div", {
    key: 73
  }, [api_element("section", {
    classMap: {
      "slds-modal": true,
      "slds-fade-in-open": true
    },
    attrs: {
      "role": "dialog",
      "tabindex": "-1",
      "aria-labelledby": api_scoped_id("modal-heading-06"),
      "aria-modal": "true",
      "aria-describedby": api_scoped_id("modal-content-id-6")
    },
    key: 74
  }, [api_element("div", {
    classMap: {
      "slds-modal__container": true,
      "fitler-modal_div": true,
      "confirm-modal_align": true
    },
    key: 75
  }, [api_element("header", {
    classMap: {
      "slds-modal__header": true
    },
    key: 76
  }, [api_element("h2", {
    classMap: {
      "slds-modal__title": true,
      "slds-hyphenate": true
    },
    attrs: {
      "id": api_scoped_id("modal-heading-06")
    },
    key: 77
  }, [api_text("Login Warning")])]), api_element("div", {
    classMap: {
      "slds-modal__content": true,
      "slds-p-around_medium": true
    },
    attrs: {
      "id": api_scoped_id("modal-content-id-6"),
      "data-my-id": "packageVersion"
    },
    key: 78
  }, [api_element("h3", {
    classMap: {
      "conf-modal_align": true
    },
    key: 79
  }, [api_text("Destination Org should have higher or Same version of A360 package than the Source Org.")]), api_element("br", {
    key: 80
  }, [])]), api_element("footer", {
    classMap: {
      "slds-modal__footer": true,
      "modal-bottom_align": true
    },
    key: 81
  }, [api_custom_element("lightning-button", _lightningButton, {
    classMap: {
      "modal-popup__margin": true
    },
    props: {
      "label": "OK",
      "variant": "brand",
      "title": "OK"
    },
    key: 82,
    on: {
      "click": _m24 || ($ctx._m24 = api_bind($cmp.closePackageVersionWarnModal))
    }
  }, [])])])]), api_element("div", {
    classMap: {
      "slds-backdrop": true,
      "slds-backdrop_open": true
    },
    key: 83
  }, [])]) : null];
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];


if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets)
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets)
}
tmpl.stylesheetToken = "my-configMigration_configMigration"
